import { createFileRoute } from "@tanstack/react-router";
import { ResetRequestForm } from "@/components/auth/reset-request-form";
import { ResetPasswordForm } from "@/components/auth/reset-password-form";
import { LayoutPageH1, PageContainer } from "@/components/primitives/layout";
import { optionalStringSearchParam } from "@/lib/searchParams";
import { z } from "zod";

const searchSchema = z.object({
  token: optionalStringSearchParam,
  email: optionalStringSearchParam,
});

export const Route = createFileRoute("/reset-password")({
  validateSearch: searchSchema,
  head: () => ({
    meta: [{ title: "Reset Password - Scoopulator" }],
  }),
  component: ResetPasswordPage,
});

function ResetPasswordPage() {
  const { token, email } = Route.useSearch();

  return (
    <PageContainer className="max-w-md space-y-6">
      <LayoutPageH1>
        {token ? "Set a new password" : "Forgot your password?"}
      </LayoutPageH1>

      {token ? (
        <ResetPasswordForm token={token} />
      ) : (
        <ResetRequestForm email={email} />
      )}
    </PageContainer>
  );
}
